import type { HSTitleSetting } from '@types';

type PresetItem = {
  text: string;
  background?: Partial<HSTitleSetting['background']>;
  font?: Partial<HSTitleSetting['font']>;
  isCustom?: boolean;
};

export const presetList: PresetItem[] = [
  {
    text: '纯色1',
    background: {
      type: 0,
      bgColor: '0,0,0,0.5',
      borderWidth: 0,
    },
  },

  {
    text: '纯色2',
    background: {
      type: 0,
      bgColor: '240,236,227,1',
      borderWidth: 0,
    },
    font: {
      fontColor: '0,0,0,0.5',
    },
  },

  {
    text: '纯色3',
    background: {
      type: 0,
      bgColor: '219,185,108,1',
      borderWidth: 0,
    },
  },

  {
    text: '纯色4',
    background: {
      type: 0,
      bgColor: '199,177,152,1',
      borderWidth: 0,
    },
    font: {
      fontColor: '0,0,0,0.5',
    },
  },

  {
    text: '纯色5',
    background: {
      type: 0,
      bgColor: '115,119,123,1',
      borderWidth: 0,
    },
  },

  {
    text: '纯色6',
    background: {
      type: 0,
      bgColor: '250,100,0,1',
      borderWidth: 0,
    },
  },

  {
    text: '纯色7',
    background: {
      type: 0,
      bgColor: '235,83,83,1',
      borderWidth: 0,
    },
  },

  {
    text: '纯色8',
    background: {
      type: 0,
      bgColor: '180,225,151,1',
      borderWidth: 0,
    },
    font: {
      fontColor: '0,0,0,0.5',
    },
  },

  {
    text: '纯色9',
    background: {
      type: 0,
      bgColor: '153,219,191,1',
      borderWidth: 0,
    },
    font: {
      fontColor: '0,0,0,0.5',
    },
  },

  {
    text: '纯色10',
    background: {
      type: 0,
      bgColor: '171,70,210,1',
      borderWidth: 0,
    },
  },

  {
    text: '纯色11',
    background: {
      type: 0,
      bgColor: '40,110,250,1',
      borderWidth: 0,
    },
  },

  {
    text: '半透明1',
    background: {
      type: 0,
      bgColor: '0,0,0,0.5',
      borderWidth: 1,
      borderColor: '168,168,168,1',
    },
  },

  {
    text: '半透明2',
    background: {
      type: 0,
      bgColor: '240,236,227,0.5',
      borderWidth: 1,
      borderColor: '240,236,227,1',
    },
  },

  {
    text: '半透明3',
    background: {
      type: 0,
      bgColor: '219,185,108,0.5',
      borderWidth: 1,
      borderColor: '219,185,108,1',
    },
  },

  {
    text: '半透明4',
    background: {
      type: 0,
      bgColor: '199,177,152,0.5',
      borderWidth: 1,
      borderColor: '199,177,152,1',
    },
  },

  {
    text: '半透明5',
    background: {
      type: 0,
      bgColor: '115,119,123,0.5',
      borderWidth: 1,
      borderColor: '190,197,203,1',
    },
  },

  {
    text: '半透明6',
    background: {
      type: 0,
      bgColor: '250,100,0,0.5',
      borderWidth: 1,
      borderColor: '250,100,0,1',
    },
  },

  {
    text: '半透明7',
    background: {
      type: 0,
      bgColor: '235,83,83,0.5',
      borderWidth: 1,
      borderColor: '235,83,83,1',
    },
  },

  {
    text: '半透明8',
    background: {
      type: 0,
      bgColor: '180,225,151,0.5',
      borderWidth: 1,
      borderColor: '180,225,151,1',
    },
  },

  {
    text: '半透明9',
    background: {
      type: 0,
      bgColor: '153,219,191,0.5',
      borderWidth: 1,
      borderColor: '153,219,191,1',
    },
  },

  {
    text: '半透明10',
    background: {
      type: 0,
      bgColor: '171,70,210,0.5',
      borderWidth: 1,
      borderColor: '171,70,210,1',
    },
  },

  {
    text: '半透明11',
    background: {
      type: 0,
      bgColor: '40,110,250,0.5',
      borderWidth: 1,
      borderColor: '78,137,255,1',
    },
  },

  {
    text: '渐变1',
    background: {
      type: 1,
      borderWidth: 0,
      gradientAngle: 0,
      gradientStartColor: '0,0,0,0.2',
      gradientEndColor: '0,0,0,0.5',
    },
  },

  {
    text: '渐变2',
    background: {
      type: 1,
      borderWidth: 0,
      gradientAngle: 0,
      gradientStartColor: '240,236,227,1',
      gradientEndColor: '212,204,184,1',
    },
    font: {
      fontColor: '0,0,0,0.5',
    },
  },

  {
    text: '渐变3',
    background: {
      type: 1,
      borderWidth: 0,
      gradientAngle: 90,
      gradientStartColor: '219,162,108,1',
      gradientEndColor: '219,185,108,1',
    },
  },

  {
    text: '渐变4',
    background: {
      type: 1,
      borderWidth: 0,
      gradientAngle: 90,
      gradientStartColor: '149,119,86,1',
      gradientEndColor: '119,177,152,1',
    },
  },

  {
    text: '渐变5',
    background: {
      type: 1,
      borderWidth: 0,
      gradientAngle: 90,
      gradientStartColor: '115,119,123,1',
      gradientEndColor: '188,195,202,1',
    },
  },

  {
    text: '渐变6',
    background: {
      type: 1,
      borderWidth: 0,
      gradientAngle: 90,
      gradientStartColor: '250,100,0,1',
      gradientEndColor: '250,183,0,1',
    },
  },

  {
    text: '渐变7',
    background: {
      type: 1,
      borderWidth: 0,
      gradientAngle: 90,
      gradientStartColor: '235,83,83,1',
      gradientEndColor: '235,146,83,1',
    },
  },

  {
    text: '渐变8',
    background: {
      type: 1,
      borderWidth: 0,
      gradientAngle: 90,
      gradientStartColor: '122,170,91,1',
      gradientEndColor: '180,225,151,1',
    },
  },

  {
    text: '渐变9',
    background: {
      type: 1,
      borderWidth: 0,
      gradientAngle: 90,
      gradientStartColor: '67,165,124,1',
      gradientEndColor: '153,219,191,1',
    },
  },

  {
    text: '渐变10',
    background: {
      type: 1,
      borderWidth: 0,
      gradientAngle: 90,
      gradientStartColor: '171,70,210,1',
      gradientEndColor: '207,135,235,1',
    },
  },

  {
    text: '渐变11',
    background: {
      type: 1,
      borderWidth: 0,
      gradientAngle: 90,
      gradientStartColor: '40,110,250,1',
      gradientEndColor: '125,200,241,1',
    },
  },
];
